import { styled } from '@mui/material'
import { memo } from 'react'
import { ReactComponent as SvgMobileLogo } from './mobile-logo.svg'
import { ReactComponent as SvgCloseMenu } from './close-menu.svg'

const Wrap = styled('div')`
  display: none;

  ${(props) => props.theme.breakpoints.down('md')} {
    display: flex;
    width: 100%;
    height: 72px;
    padding: 0 8px 0 16px;
    background: rgba(22, 25, 30, 1);
    align-items: center;
    justify-content: space-between;
  }
`
const CloseButton = styled('button')`
  width: 40px;
  height: 40px;
  align-items: center;
  justify-content: center;
  padding: 0;
  background-color: transparent;
  border: none;
`
export const MobileHead = memo<{
  onClose?(): void
}>(({ onClose }) => {
  return (
    <Wrap>
      <SvgMobileLogo />
      <CloseButton
        onClick={() => {
          onClose && onClose()
        }}
      >
        <SvgCloseMenu />
      </CloseButton>
    </Wrap>
  )
})
